import { render, staticRenderFns } from "./AdminCampaignsTable.vue?vue&type=template&id=483e3f34&scoped=true"
import script from "./AdminCampaignsTable.vue?vue&type=script&lang=js"
export * from "./AdminCampaignsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e3f34",
  null
  
)

export default component.exports